export default class Functions
{

    constructor()
    {
        this.registerPrototypes()
        return this
    }

    registerPrototypes()
    {
        String.prototype.hash = function()
        {

            let hash = 0;
            for( let charIndex = 0; charIndex < this.length; ++charIndex )
            {
                hash += this.charCodeAt( charIndex );
                hash += hash << 10;
                hash ^= hash >> 6;
            }
            hash += hash << 3;
            hash ^= hash >> 11;
            //4,294,967,295 is FFFFFFFF, the maximum 32 bit unsigned integer value, used here as a mask.
            return ( ( ( hash + ( hash << 15 ) ) & 4294967295 ) >>> 0 ).toString( 16 )

        }
    }

    ucFirst( string )
    {
        return string.charAt( 0 ).toUpperCase() + string.slice( 1 )
    }

    lcFirst( string )
    {
        return string.charAt( 0 ).toLowerCase() + string.slice( 1 )
    }

    deviceHash( item, returnValue )
    {

        if( undefined !== item.elementKey )
        {
            delete item.elementKey
        }

        let str = JSON.stringify( item )
        let i, l, key,
            hval = 0x2961987

        for( i = 0, l = str.length; i < l; i++ )
        {
            hval ^= str.charCodeAt( i )
            hval += ( hval << 1 ) + ( hval << 4 ) + ( hval << 7 ) + ( hval << 8 ) + ( hval << 24 )
        }

        key = ( '00000000' + ( hval >>> 0 ).toString( 16 ) ).substr( -8 )

        if( 'object' === typeof item
            && undefined === returnValue )
        {
            item.elementKey = key
        }

        return key

    }

    promiseRunner( promises )
    {
        return new Promise( resolve =>
        {

            let promise = promises.reduce( ( todo, task ) =>
            {
                return todo.then( () =>
                {
                    return task()
                } )
            }, Promise.resolve() )

            promise.then( () =>
            {
                return resolve()
            } )

        } )
    }

    calculateGraph( x, desired, niveau, gradient )
    {

        return desired
               + niveau
               - ( gradient *
                   ( x - desired ) * ( 1.4347 + ( 0.022 * ( x - desired ) )
                                       + ( 247.9 * Math.pow( 10, -6 ) )
                                       * Math.pow( ( x - desired ), 2 ) ) )

    }

    generateGraphData( desired, niveau, gradient, iStart, iEnd, step = 1, data, night )
    {

        for( let x = iStart; x >= iEnd; x -= step )
        {

            if( -1 === data.x.indexOf( x ) )
            {
                data.x.push( x )
            }
            let _y = Math.round( this.calculateGraph( x, desired, niveau, gradient ) * 10 ) / 10
            switch( night )
            {
                case true:
                    data.y_night.push( _y )
                    break
                default:
                    data.y_default.push( _y )
            }

        }

    }

}